import './index.css';
import { get, getDictionaryItem, generatrURLFromTags, getTags, getVideoItemURL, getMediaHost, pathJoin, injectImageResolution, canUseDOM } from '../../utils';
import React from 'react';
import { useInView } from 'react-intersection-observer';
import ComponentsWrapper from '../atoms/ComponentsWrapper';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
import CarouselProvider from '../atoms/CarouselProvider/CarouselProvider';
import ScrollAnimation from 'react-animate-on-scroll';
import RouterLink from '../atoms/RouterLink';
import getListing from '../../utils/getListing';
import LazyPicture from '../atoms/LazyPicture';
import { Text } from '@sitecore-jss/sitecore-jss-react';
import { ReactComponent as ChevronRight } from '../../resources/icons/IconChevronRightLight.svg';
import { ReactComponent as ChevronLeft } from '../../resources/icons/IconChevronLeftLight.svg';
import { handleAnalitics } from '../../utils/tealium';
const isLargeImage = function (index, isSlider) {
  let isMobile = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  let length = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 8;
  if (isSlider === false) {
    if (isMobile && length <= 4) return [0, 3].includes(index % 8);
    return [0, 7].includes(index % 8);
  }
  return false;
};
export const VideoBlock = _ref => {
  let {
    item,
    isSlider,
    index,
    params,
    analytics,
    discoverMoreLink,
    isLarge = false,
    hostLink,
    blockTitle
  } = _ref;
  const category = get(item, 'category', []);

  //const isLarge = isSlider? false : get(item, 'featured');
  const [hovered, setHovered] = React.useState(false);
  const isMobile = canUseDOM ? window.matchMedia(`(max-width: 768px)`).matches : false;
  const width = isLarge ? '460' : '220';
  const verticalPosterImage = get(item, 'verticalPosterImage');
  const horizontalPosterImage = get(item, 'horizontalPosterImage');
  const image = isLarge ? horizontalPosterImage ? horizontalPosterImage : item.image : verticalPosterImage ? verticalPosterImage : item.image;
  const verticalGif = get(item, 'verticalGif');
  const horizontalGif = get(item, 'horizontalGif');
  const gif = isLarge ? horizontalGif ? horizontalGif : null : verticalGif ? verticalGif : null;
  const imgSrc = injectImageResolution(`${pathJoin([getMediaHost(), image])}`, width, '346');
  const gifSrc = injectImageResolution(`${pathJoin([getMediaHost(), gif])}`, width, '346');
  return /*#__PURE__*/React.createElement("div", {
    className: `videoItem ${videoItemStyles}`
  }, /*#__PURE__*/React.createElement("div", {
    className: "videoItem__image"
  }, /*#__PURE__*/React.createElement(ScrollAnimation, {
    animateIn: "animate__fadeInUp",
    animateOnce: true,
    duration: 0.8
  }, item.url && /*#__PURE__*/React.createElement(RouterLink, {
    href: getVideoItemURL(item.url),
    openInSameTab: true,
    onClick: () => handleAnalitics({
      params: params,
      title: item.englishTitle,
      objectParamName: 'Banner Click Param',
      objectParams: analytics
    }),
    title: item.title
  }, /*#__PURE__*/React.createElement(ScrollAnimation, {
    animateIn: "animate__fadeIn",
    animateOnce: true,
    duration: 1
  }, /*#__PURE__*/React.createElement("div", {
    className: gif && !isMobile ? 'hover-media' : ''
  }, /*#__PURE__*/React.createElement("div", {
    className: gif && !isMobile ? 'static-image' : ''
  }, /*#__PURE__*/React.createElement(LazyPicture, {
    useEmptyPlaceholder: true,
    hover: false
  }, /*#__PURE__*/React.createElement("source", {
    media: "(min-width: 768px)",
    srcSet: imgSrc
  }), /*#__PURE__*/React.createElement("img", {
    src: imgSrc,
    "aria-hidden": "true",
    alt: item.title
  }))), gif && !isMobile && /*#__PURE__*/React.createElement("div", {
    className: 'hovered-image'
  }, /*#__PURE__*/React.createElement(LazyPicture, {
    useEmptyPlaceholder: true,
    hover: false
  }, /*#__PURE__*/React.createElement("source", {
    media: "(min-width: 768px)",
    srcSet: gifSrc
  }), /*#__PURE__*/React.createElement("img", {
    src: gifSrc,
    "aria-hidden": "true",
    alt: item.title
  })))))))), category.length ? /*#__PURE__*/React.createElement("div", {
    className: "videoItem__categories"
  }, category.map(elem => {
    const ariaLabel = blockTitle ? `${blockTitle} | ${elem}` : elem;
    return /*#__PURE__*/React.createElement("a", {
      href: `${discoverMoreLink}?category=${elem}`,
      "aria-label": ariaLabel
    }, /*#__PURE__*/React.createElement("span", null, elem));
  })) : '', item.title && /*#__PURE__*/React.createElement(ScrollAnimation, {
    animateIn: "animate__fadeInUp",
    animateOnce: true,
    duration: 1.05
  }, /*#__PURE__*/React.createElement("div", {
    className: "body-medium videoItem__title"
  }, /*#__PURE__*/React.createElement(RouterLink, {
    href: getVideoItemURL(item.url),
    openInSameTab: true,
    onClick: () => handleAnalitics({
      params: params,
      title: item.englishTitle,
      objectParamName: 'Title Click Param',
      objectParams: analytics
    })
  }, item.title))), item.introText && /*#__PURE__*/React.createElement(ScrollAnimation, {
    animateIn: "animate__fadeInUp",
    animateOnce: true,
    duration: 1.05
  }, /*#__PURE__*/React.createElement("div", {
    className: "body-medium videoItem__description"
  }, /*#__PURE__*/React.createElement("p", null, item.introText))));
};
const BrightcoveVideos = _ref2 => {
  let {
    fields,
    params
  } = _ref2;
  const sitecoreContext = React.useContext(SitecoreContextReactContext);
  const rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  const pageEditing = Boolean(sitecoreContext && sitecoreContext.pageEditing);
  const algoliaSettings = {
    key: get(sitecoreContext, 'configuration.algolia.algoliaApiKey'),
    id: get(sitecoreContext, 'configuration.algolia.algoliaApplicationId'),
    fullTextSearchIndex: get(sitecoreContext, 'configuration.algolia.fullTextSearchIndex')
  };
  const [hits, setHits] = React.useState(['1']);
  const [seeMoreURLTags, setSeeMoreURLTags] = React.useState('');
  const searchCount = Number(get(params, 'SearchCount'));
  const contextTags = getTags(get(fields, 'data.contextItem.tags'), 'tags:');
  const itemTags = getTags(get(fields, 'data.datasource.tags'), 'tags:');
  const indexName = get(params, 'SearchIndex');
  const isMobile = canUseDOM ? window.matchMedia(`(max-width: 768px)`).matches : false;
  const uid = get(params, 'uid');
  const itemType = 'Video Details Page';
  const headerTitle = get(fields, 'data.datasource.title.jss');
  const isSlider = get(fields, 'data.datasource.isSlider.jss.value', false);
  const discoverMoreLink = get(fields, 'data.overviewButton.link.jss.value.href');
  const discoverMoreLinkTitle = get(fields, 'data.overviewButton.title.jss.value');
  const dictionary = get(fields, 'data.dictionary');
  const seeMoreTitle = getDictionaryItem(dictionary, 'see more') || '';
  const description = get(fields, 'data.datasource.description.jss.value');
  const currentItemIdString = get(sitecoreContext, 'route.itemId');
  const currentItemId = currentItemIdString && currentItemIdString.replace(/-/g, '');
  const datasourceTags = get(fields, 'data.datasource.tags.values') || [];
  const pageTagsCheckbox = get(fields, 'data.datasource.considerPageLevelTags.jss.value') || false;
  const pageTags = get(fields, 'data.contextItem.tags.values') || [];
  const tagsList = pageTagsCheckbox ? [...datasourceTags, ...pageTags] : [...datasourceTags];
  const analytics = get(fields, 'data.analytics.parameters');
  const [ref, inView] = useInView({
    threshold: 0.1,
    triggerOnce: true
  });
  if (!fields) {
    console.info('BrightcoveVideosHeader component render skipped. No fields provided');
    if (pageEditing) {
      return /*#__PURE__*/React.createElement("div", {
        className: "no-data"
      }, "[BrightcoveVideosHeader component is empty: please provide data source]");
    }
    return null;
  }
  /*eslint-disable */

  React.useEffect(() => {
    if (inView) {
      setSeeMoreURLTags(generatrURLFromTags(tagsList, 'tags'));
      let itemFilter = {
        hitsPerPage: searchCount > 8 ? 8 : searchCount,
        facetFilters: [[`type:${itemType}`], [...contextTags, ...itemTags]
        //[`featured:1`]
        //[contextItemId ? `curators.curators.Id:${contextItemId}` : ''],
        ],
        filters: currentItemId ? `NOT objectID:${currentItemId}` : ''
      };
      getListing(indexName, itemFilter, algoliaSettings).then(hits => {
        if (hits) {
          !isSlider && hits.hits.splice(Math.max(1, Math.floor(hits.hits.length / 4)) * 4);
          setHits(hits.hits);
        }
      });
    }
  }, [inView]);
  /*eslint-disable */

  const renderTileItems = hostLink => {
    return hits.map((item, index) => {
      const isLarge = isLargeImage(index, isSlider, isMobile, hits.length);
      //const isLarge = isSlider? false : get(item, 'featured');
      //const itemId = get(item, 'objectID')
      // if(itemId == currentItemId)
      // 	return null
      // else
      return /*#__PURE__*/React.createElement("div", {
        className: `${isLarge ? 'video__large' : 'video__medium'}`
      }, /*#__PURE__*/React.createElement(ScrollAnimation, {
        animateIn: "animate__fadeInUp",
        delay: 0,
        animateOnce: true,
        duration: 1 + index / 3
      }, /*#__PURE__*/React.createElement(VideoBlock, {
        key: index,
        index: index,
        item: item,
        isSlider: isSlider,
        isLarge: isLarge,
        hostLink: hostLink,
        discoverMoreLink: discoverMoreLink,
        analytics: analytics,
        params: params,
        blockTitle: headerTitle.value
      })));
    });
  };
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl,
    anchorUrlParameter: params['Anchor Url Parameter']
  }, /*#__PURE__*/React.createElement("div", {
    className: "container",
    ref: ref
  }, /*#__PURE__*/React.createElement("div", {
    className: `module-group`
  }, /*#__PURE__*/React.createElement("div", {
    className: "videosCarousel--holder row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-12 col-xl-10 offset-xl-1 "
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-xl-11 h-title-x"
  }, /*#__PURE__*/React.createElement(ScrollAnimation, {
    animateIn: "animate__fadeInUp",
    animateOnce: true,
    duration: 1,
    delay: 0
  }, /*#__PURE__*/React.createElement(Text, {
    className: `videos__title h2`,
    tag: "h2",
    field: headerTitle
  }), description && /*#__PURE__*/React.createElement("p", {
    className: "videos__description"
  }, description)))), /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-xl-12 videos__multiple"
  }, /*#__PURE__*/React.createElement("div", {
    className: "videos__multiple--list row"
  }, !isSlider ? /*#__PURE__*/React.createElement("div", {
    className: "col-md-12"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row videos__multiple--list-noCarousel"
  }, renderTileItems('')), discoverMoreLinkTitle && /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-sm-12"
  }, /*#__PURE__*/React.createElement(ScrollAnimation, {
    animateIn: "animate__fadeInUp",
    animateOnce: true,
    duration: 1,
    delay: 100
  }, /*#__PURE__*/React.createElement("div", {
    className: "videos__link"
  }, /*#__PURE__*/React.createElement(RouterLink, {
    openInSameTab: true,
    className: "btn btn-link btn-desk",
    href: discoverMoreLink + seeMoreURLTags,
    onClick: () => handleAnalitics({
      params: params,
      title: '',
      objectParamName: 'See More Param',
      objectParams: analytics
    }),
    ariaLabel: `${headerTitle.value} | ${discoverMoreLinkTitle}`
  }, discoverMoreLinkTitle, rtl ? /*#__PURE__*/React.createElement(ChevronLeft, {
    className: "btn-link__icon btn-link-icon"
  }) : /*#__PURE__*/React.createElement(ChevronRight, {
    className: "btn-link__icon btn-link-icon"
  })), /*#__PURE__*/React.createElement(RouterLink, {
    openInSameTab: true,
    className: "btn btn-primary btn-mob rs_skip",
    href: discoverMoreLink + seeMoreURLTags,
    onClick: () => handleAnalitics({
      params: params,
      title: '',
      objectParamName: 'See More Param',
      objectParams: analytics
    })
    //onClick={() => tealiumClickFunc(tealiumMergeClickData(seeMoreAnalytics, params))}
  }, discoverMoreLinkTitle)))))) : /*#__PURE__*/React.createElement("div", {
    className: "col-md-12"
  }, /*#__PURE__*/React.createElement(CarouselProvider, null, _ref3 => {
    let {
      renderCarousel,
      renderPreviousButton,
      renderNextButton,
      renderDots,
      state
    } = _ref3;
    return /*#__PURE__*/React.createElement("div", {
      className: "col-xs-12"
    }, /*#__PURE__*/React.createElement("div", {
      className: `videos__items`
    }, renderCarousel(renderTileItems(''), {
      responsive: {
        desktop: {
          breakpoint: {
            max: 10000,
            min: 768
          },
          items: 5
        },
        tablet: {
          breakpoint: {
            max: 1200,
            min: 768
          },
          items: 5
        },
        mobileLandscape: {
          breakpoint: {
            max: 767,
            min: 480
          },
          items: 2
        },
        mobile: {
          breakpoint: {
            max: 479,
            min: 0
          },
          items: 2
        }
      }
    }, isNext => handleAnalitics({
      params: params,
      title: '',
      objectParamName: isNext ? 'Slide Right Param' : 'Slide Left Param',
      objectParams: analytics
    })), /*#__PURE__*/React.createElement("div", {
      className: "article-navigation__row"
    }, /*#__PURE__*/React.createElement("div", {
      className: `article-navigation__btn btn-group--left ${rtl ? 'btn-group-rtl' : ''}`
    }, renderPreviousButton(() => handleAnalitics({
      params: params,
      title: '',
      objectParamName: 'Previous Param',
      objectParams: analytics
    }))), /*#__PURE__*/React.createElement("div", {
      className: `article-navigation__btn btn-group--right ${rtl ? 'btn-group-rtl' : ''}`
    }, renderNextButton(() => handleAnalitics({
      params: params,
      title: '',
      objectParamName: 'Next Param',
      objectParams: analytics
    })))), /*#__PURE__*/React.createElement("div", {
      className: "c-pagination__dots"
    }, renderDots(() => handleAnalitics({
      params: params,
      title: '',
      objectParamName: 'Navigator Bubbles Param',
      objectParams: analytics
    })))));
  }), discoverMoreLinkTitle && /*#__PURE__*/React.createElement("div", {
    className: "col-sm-12"
  }, /*#__PURE__*/React.createElement(ScrollAnimation, {
    animateIn: "animate__fadeInUp",
    animateOnce: true,
    duration: 1,
    delay: 400
  }, /*#__PURE__*/React.createElement("div", {
    className: "videos__link"
  }, /*#__PURE__*/React.createElement(RouterLink, {
    openInSameTab: true,
    className: "btn btn-link btn-desk",
    href: discoverMoreLink + seeMoreURLTags,
    onClick: () => handleAnalitics({
      params: params,
      title: '',
      objectParamName: 'See More Param',
      objectParams: analytics
    }),
    ariaLabel: `${headerTitle.value} | ${discoverMoreLinkTitle}`
  }, discoverMoreLinkTitle, rtl ? /*#__PURE__*/React.createElement(ChevronLeft, {
    className: "btn-link__icon btn-link-icon"
  }) : /*#__PURE__*/React.createElement(ChevronRight, {
    className: "btn-link__icon btn-link-icon"
  })), /*#__PURE__*/React.createElement(RouterLink, {
    openInSameTab: true,
    className: "btn btn-primary btn-mob rs_skip",
    href: discoverMoreLink + seeMoreURLTags,
    onClick: () => handleAnalitics({
      params: params,
      title: '',
      objectParamName: 'See More Param',
      objectParams: analytics
    })
  }, discoverMoreLinkTitle)))))))))))));
};
const StyledWrapper = _ref4 => {
  let {
    children,
    rtl,
    anchorUrlParameter
  } = _ref4;
  return /*#__PURE__*/React.createElement(ComponentsWrapper, {
    anchorUrlParameter: anchorUrlParameter,
    fullWidth: true,
    minHeight: true,
    className: ` ${videoMedia} ${commonStyles} ${rtl ? rtlStyles : ltrStyles}`
  }, children);
};
export const videoMedia = "v1sy3slg";
const commonStyles = "c1xjsyvd";
const rtlStyles = "rh81elw";
const ltrStyles = "l11ebavu";
const videoItemStyles = "vmmzpim";
export default BrightcoveVideos;